module.exports = __webpack_public_path__ + "img/newbb.0c73c9e2.jpg";